<script setup lang="ts">
/**
 * @author Giorgi Tseradze
 */

import type { SecondaryDataInterface } from "@/types/ContentType";
const Picture = defineAsyncComponent(
  () => import("@/components/regularComponents/UIComponents/Picture.vue")
);

defineProps<{
  contentData: SecondaryDataInterface;
}>();
</script>

<template>
  <section class="gumbati-banner pos-rel">
    <div class="container">
      <div v-if="contentData?.conf?.header?.title" class="gumbati-banner__header">
        <div class="gumbati-banner__header-title">
          <h1 class="hl-1 uppercase">{{ contentData?.conf?.header?.title }}</h1>
        </div>
        <div class="gumbati-banner__header-teaser">
          <h2 class="hl-2">{{ contentData?.conf?.header?.teaser }}</h2>
        </div>
      </div>
      <div class="gumbati-banner__inner pos-rel">
        <div class="gumbati-banner__inner-image pos-rel">
          <Picture
            :devices="contentData?.data?.list?.[0]?.image?.[0]?.devices"
            :alt="contentData?.conf?.header?.title"
            imgClass="img-absolute"
          />
        </div>

        <div class="gumbati-banner__inner-card pos-abs">
          <h3 class="hl-3">{{ contentData?.data?.list?.[0]?.title }}</h3>
          <div class="p-16" v-html="contentData?.data?.list?.[0]?.teaser" />
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" src="./styles/gumbati-banner.scss" />
